var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBtnInsights(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    rx: 8.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3438 10.6875C11.3438 10.8083 11.2458 10.9062 11.125 10.9062H5.875C5.75419 10.9062 5.65625 10.8083 5.65625 10.6875V6.3125C5.65625 6.19169 5.75419 6.09375 5.875 6.09375C5.99581 6.09375 6.09375 6.19169 6.09375 6.3125V8.89293L7.4809 7.67969C7.55869 7.61159 7.67354 7.60725 7.75625 7.6693L9.36434 8.87543L10.9809 7.46094C11.0387 7.40377 11.1233 7.38332 11.2008 7.40785C11.2783 7.43238 11.3358 7.49784 11.3501 7.57783C11.3644 7.65782 11.3332 7.73917 11.2691 7.78906L9.5191 9.32031C9.44131 9.38841 9.32646 9.39275 9.24375 9.3307L7.63566 8.12512L6.09375 9.47426V10.4688H11.125C11.2458 10.4688 11.3438 10.5667 11.3438 10.6875Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnInsights);
export default __webpack_public_path__ + "static/media/btn_insights.faaeda482d09e08ebf5d4daf5d78d973.svg";
export { ForwardRef as ReactComponent };